/**
 * Registers Foundation configuration and initializes all site-wide behaviors.
 */
function init() {
  initFoundation();
  initOrbit();
  initExternalLinks();
}

// =============================================================================================
// FOUNDATION
// =============================================================================================

/**
 * Registers Foundation defaults and initializes Foundation on the document.
 */
function initFoundation() {
  Foundation.Abide.defaults.validators['require-checkbox'] = checkboxValidator;
  Foundation.Abide.defaults.patterns['minlength'] = /^(.){6,}$/;
  Foundation.Abide.defaults.patterns['phone-number'] = /^[0-9+()\s-]*$/;
  Foundation.Orbit.defaults.timerDelay = 4500;
  $(document).foundation();
}

/**
 * Custom Abide validator requiring a minimum number of checked boxes within a group.
 * Expects the group container to carry a `data-abide-validator-min` attribute.
 *
 * @param {jQuery} $el The element being validated.
 * @param {boolean} required Whether the element is required per the `[required]` attribute.
 * @param {jQuery} parent The parent of `$el`.
 * @returns {boolean} Whether validation passed.
 */
function checkboxValidator(
  $el,      /* jQuery element to validate */
  required, /* is the element required according to the `[required]` attribute */
  parent    /* parent of the jQuery element `$el` */
) {
  const group = parent.closest('.checkbox-group');
  const min = parseInt(group.attr('data-abide-validator-min'), 10);
  const checked = group.find(':checked').length;
  if (checked >= min) {
    // clear label highlight
    group.find('label').each(function() {
      this.classList.remove('is-invalid-label');
    });
    // clear checkbox error
    group.find(':checkbox').each(function() {
      $(this).removeClass('is-invalid-input').removeAttr('data-invalid');
    });
    group.find('.form-error').hide();
    return true;
  }
  else {
    group.find('.form-error').show();
    return false;
  }
}

/**
 * Fixes Foundation's Orbit pause-on-hover by binding mouseleave on the outer [data-orbit]
 * element to restart the autoplay timer reliably on exit.
 *
 * Foundation's built-in mouseover/mouseout fires on every child element transition, not just
 * the outer boundary, which can leave the timer stuck in a paused state after the mouse leaves.
 */
function initOrbit() {
  document.querySelectorAll('[data-orbit]').forEach(el => {
    el.addEventListener('mouseleave', () => {
      const plugin = $(el).data('zfPlugin');
      if (plugin && plugin.options.autoPlay && plugin.timer) {
        plugin.timer.restart();
      }
    });
  });
}

// =============================================================================================
// LINKS
// =============================================================================================

/**
 * Opens external links (those pointing to a different hostname) in a new tab.
 */
function initExternalLinks() {
  document.querySelectorAll('a[href^="http"]').forEach(el => {
    if (el.hostname !== location.hostname) {
      el.setAttribute('target', '_blank');
      el.setAttribute('rel', 'noopener noreferrer');
    }
  });
}

init();